import React, { useState, useEffect } from 'react';
import { Icon } from '@iconify/react';

const ThemeToggleButton = () => {
    // 1. Initialize state for the current theme
    const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
    
    // 2. Removed force re-render (not needed with proper CSS variables)

    // 2. Function to update the theme on the HTML element
    const updateThemeOnHtmlEl = (theme) => {
        document.documentElement.setAttribute('data-theme', theme);
    };

    // 4. On initial render, set the theme from localStorage
    useEffect(() => {
        updateThemeOnHtmlEl(theme);
    }, [theme]);

    // 5. Toggle theme when button is clicked
    const handleThemeToggle = () => {
        const newTheme = theme === 'dark' ? 'light' : 'dark';
        setTheme(newTheme);
        localStorage.setItem('theme', newTheme);
        updateThemeOnHtmlEl(newTheme);
    };

    return (
        <button
            type="button"
            data-theme-toggle
            title={theme === 'dark' ? 'Mudar pra tema claro' : 'Mudar pra tema escuro'}
            className="d-flex justify-content-center align-items-center rounded-circle"
            style={{
                width: '40px',
                height: '40px',
                backgroundColor: theme === 'dark' ? '#2d2d2d' : '#f8f9fa',
                border: theme === 'dark' ? '1px solid #404040' : '1px solid #e9ecef',
                transition: 'all 0.2s ease',
                color: theme === 'dark' ? '#ffffff' : '#6c757d',
                cursor: 'pointer',
                padding: 0,
            }}
            onClick={handleThemeToggle}
            onMouseEnter={(e) => {
                // QA: usar currentTarget pra não afetar o ícone interno
                e.currentTarget.style.backgroundColor = theme === 'dark' ? '#404040' : '#e9ecef';
                e.currentTarget.style.transform = 'scale(1.05)';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = theme === 'dark' ? '#2d2d2d' : '#f8f9fa';
                e.currentTarget.style.transform = 'scale(1)';
            }}
        >
            <Icon
                icon={theme === 'dark' ? 'solar:sun-bold' : 'solar:moon-bold'}
                style={{
                    fontSize: '20px',
                    // QA: contraste maior em light mode (era #6c757d cinza em fundo cinza)
                    color: theme === 'dark' ? '#ffc107' : '#4f46e5',
                    pointerEvents: 'none',
                }}
            />
        </button>
    );
};

export default ThemeToggleButton;
